import config from '../../../config';
import { PredefinedMilisecondsTypeEnum } from '../../enums';
import { LoggerService } from '../logger/Logger.service';
import { SocketRequestType } from '../subscription/types';

import { BaseWebSocketService } from './BaseWebSocket.service';

const LOG_PREFIX = '[GW-WS-V2]';
const logger = LoggerService.getLogger();

export class GatewayWebSocketService extends BaseWebSocketService<SocketRequestType> {
  private static instance: GatewayWebSocketService;

  // eslint-disable-next-line no-useless-constructor
  private constructor(loginTimeout: PredefinedMilisecondsTypeEnum) {
    super(loginTimeout);
    // In order to avoid having multiple instances constructor is set as private
  }

  static getInstance(
    loginTimeout = PredefinedMilisecondsTypeEnum.fiveSeconds,
  ): GatewayWebSocketService {
    if (!this.instance) {
      logger.log(`${LOG_PREFIX} Creating new instance`);
      this.instance = new GatewayWebSocketService(loginTimeout);
    }

    logger.log(`${LOG_PREFIX} Returning existing instance`);
    return this.instance;
  }

  protected getBaseUrl = (): string => `wss://${config.gateway.url}/push`;
}
